import styled from 'styled-components';
import { IconButton } from '../icon-button';
import { getSizeBy } from '../../../src/styled/utils';
export const SliderWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
`;
export const NavButton = styled(IconButton) `
  padding: ${getSizeBy(1)};
  visibility: ${({ $isVisible }) => ($isVisible ? 'initial' : 'hidden')};
  cursor: pointer;
`;
